import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import HeaderEN from './components/HeaderEN';
import Hero from './components/Hero';
import HeroEN from './components/HeroEN';
import About from './components/About';
import AboutEN from './components/AboutEN';
import Donate from './components/Donate';
import DonateEN from './components/DonateEN';
import Footer from './components/Footer';
import FooterEN from './components/FooterEN';
import Impressum from './components/Impressum';
import ImprintEN from './components/ImprintEN';
import Datenschutz from './components/Datenschutz';
import PrivacyEN from './components/PrivacyEN';
import Transparenz from './components/Transparenz';
import TransparencyEN from './components/TransparencyEN';
import CookieConsent from './components/CookieConsent';
import CookieConsentEN from './components/CookieConsentEN';

function App() {
  return (
    <Router>
      <Routes>
        {/* German Routes */}
        <Route path="/" element={
          <div className="App bg-warm-beige min-h-screen">
            <Header />
            <main>
              <Hero />
              <About />
              <Donate />
            </main>
            <Footer />
            <CookieConsent />
          </div>
        } />
        <Route path="/about" element={
          <div className="App bg-warm-beige min-h-screen">
            <Header />
            <About />
            <Footer />
            <CookieConsent />
          </div>
        } />
        <Route path="/donate" element={
          <div className="App bg-warm-beige min-h-screen">
            <Header />
            <Donate />
            <Footer />
            <CookieConsent />
          </div>
        } />
        <Route path="/impressum" element={
          <div className="App bg-warm-beige min-h-screen">
            <Header />
            <Impressum />
            <Footer />
            <CookieConsent />
          </div>
        } />
        <Route path="/datenschutz" element={
          <div className="App bg-warm-beige min-h-screen">
            <Header />
            <Datenschutz />
            <Footer />
            <CookieConsent />
          </div>
        } />
        <Route path="/transparenz" element={
          <div className="App bg-warm-beige min-h-screen">
            <Header />
            <Transparenz />
            <Footer />
            <CookieConsent />
          </div>
        } />
        
        {/* English Routes */}
        <Route path="/en" element={
          <div className="App bg-warm-beige min-h-screen">
            <HeaderEN />
            <main>
              <HeroEN />
              <AboutEN />
              <DonateEN />
            </main>
            <FooterEN />
            <CookieConsentEN />
          </div>
        } />
        <Route path="/en/about" element={
          <div className="App bg-warm-beige min-h-screen">
            <HeaderEN />
            <AboutEN />
            <FooterEN />
            <CookieConsentEN />
          </div>
        } />
        <Route path="/en/donate" element={
          <div className="App bg-warm-beige min-h-screen">
            <HeaderEN />
            <DonateEN />
            <FooterEN />
            <CookieConsentEN />
          </div>
        } />
        <Route path="/en/transparency" element={
          <div className="App bg-warm-beige min-h-screen">
            <HeaderEN />
            <TransparencyEN />
            <FooterEN />
            <CookieConsentEN />
          </div>
        } />
        <Route path="/en/imprint" element={
          <div className="App bg-warm-beige min-h-screen">
            <HeaderEN />
            <ImprintEN />
            <FooterEN />
            <CookieConsentEN />
          </div>
        } />
        <Route path="/en/privacy" element={
          <div className="App bg-warm-beige min-h-screen">
            <HeaderEN />
            <PrivacyEN />
            <FooterEN />
            <CookieConsentEN />
          </div>
        } />
      </Routes>
    </Router>
  );
}

export default App;